import { useEffect } from 'react';

const SecurityHeaders = () => {
  useEffect(() => {
    // Important: Do NOT inject a CSP via meta tag here. A meta CSP combines with
    // server-set CSP headers and can unintentionally block required third-parties
    // like Stripe, Maps, Vimeo, etc. Manage CSP centrally via server config
    // (e.g., vercel.json and Vite dev server headers).

    // Safe client-side meta: Referrer Policy (allowed via meta)
    const ensureReferrerPolicy = () => {
      let referrerPolicy = document.querySelector('meta[name="referrer"]');
      if (!referrerPolicy) {
        referrerPolicy = document.createElement('meta');
        referrerPolicy.setAttribute('name', 'referrer');
        referrerPolicy.setAttribute('content', 'strict-origin-when-cross-origin');
        document.head.appendChild(referrerPolicy);
      }
    };

    ensureReferrerPolicy();

    // Opportunistic performance hint: preconnect to Stripe hosts
    // Safe to add globally; no secrets are exposed and this can reduce TLS handshake time.
    const preconnects: HTMLLinkElement[] = [];
    const addPreconnect = (href: string) => {
      const el = document.createElement('link');
      el.rel = 'preconnect';
      el.href = href;
      el.crossOrigin = 'anonymous';
      document.head.appendChild(el);
      preconnects.push(el);
    };
    try {
      addPreconnect('https://js.stripe.com');
      addPreconnect('https://api.stripe.com');
    } catch {}

  // Additional client-side security measures
  // NOTE: Do not block the native context menu globally to allow "Guardar imagen como…" in galleries.

    const handleSelectStart = (e: Event) => {
      // Disable text selection on sensitive elements
      const target = e.target;
      if (target && target instanceof HTMLElement && target.classList.contains('no-select')) {
        e.preventDefault();
      }
    };

    // Add event listeners
  document.addEventListener('selectstart', handleSelectStart);

    // Cleanup
    return () => {
      document.removeEventListener('selectstart', handleSelectStart);
      // Remove preconnect links on cleanup to avoid duplicates if this component remounts
      try { preconnects.forEach((el) => el.remove()); } catch {}
    };
  }, []);

  return null; // This component doesn't render anything
};

export default SecurityHeaders;
